import { render, staticRenderFns } from "./Consumptions_old.vue?vue&type=template&id=374d89b6"
import script from "./Consumptions_old.vue?vue&type=script&lang=js"
export * from "./Consumptions_old.vue?vue&type=script&lang=js"
import style0 from "./Consumptions_old.vue?vue&type=style&index=0&id=374d89b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports